import salesReducer from './salesReportReducer';

export default ({
    salesReport: salesReducer
});